function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M128 256c0 35-29 64-64 64S0 291 0 256s29-64 64-64 64 29 64 64zm192 0c0 35-29 64-64 64s-64-29-64-64 29-64 64-64 64 29 64 64zm192 0c0 35-29 64-64 64s-64-29-64-64 29-64 64-64 64 29 64 64z"
})));